import React, { Component } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import CBMediaQuery from '../../shared/CBMediaQuery';
import '../../../App.css';
import {finnishDateFormat, getStyle, SERVICE_FLEET, SERVICE_WORKSHOP, storeRemoveItem, storeInsertItem, dbDateFormat, formatDateTime } from '../../../utils/utils';
import CBModal from '../../shared/CBModal';
import {
    fetchCheckLists as _fetchCheckLists,
    fetchVehicleCheckListItems as _fetchVehicleCheckListItems,
    toggleVehicleChecks as _toggleVehicleChecks
  } from '../../../actions/checkListActions';
import CBDatePickerInput from '../../shared/CBDatePickerInput';
import moment from 'moment';
import CBLabelAndCheckbox from '../../shared/CBLabelAndCheckbox';
import CBPromptModal from '../../shared/CBPromptModal';
import { Tooltip } from 'primereact/tooltip';


class SelectCheckListItemsModal extends Component {
  constructor(props) {
    super(props);

    const { vehicle } = props;

    this.state = {
      vehicleCheckListItemsSet: false,
      formData: {
        check_list_id: null,
        vehicle_id: vehicle.id,
        items: []
      },
      // The check whose new date may also become a hoitomerkintä: { id, name }.
      treatmentPromptItem: null,
    };
  }

  componentDidMount = async () => {
    const {
      fetchVehicleCheckListItems,
      vehicle,
      selectedOrganizationId,
      selectedWorkshopId
    } = this.props;

    const params = {
      vehicle_id: vehicle.id
    };

    if (selectedOrganizationId) {
      params.organization_id = vehicle.organization_id;
    } else if (selectedWorkshopId) {
      params.workshop_id = selectedWorkshopId;
    }

    this.setState({
      vehicleCheckListItemsSet: false,
      loading: true
    });


      // Wait for both API calls to finish
    await Promise.all([
      fetchVehicleCheckListItems(params),
      this.fetchCheckLists()
    ]);

    this.setState({
      loading: false
    });
  };

  componentDidUpdate = (prevProps) => {
    const {
      vehicleCheckListItems,
      checkLists,
      vehicle
    } = this.props;

    const { formData, vehicleCheckListItemsSet } = this.state;

    if (vehicleCheckListItems.length && !formData.items.length && !vehicleCheckListItemsSet) {
      this.setState({
        vehicleCheckListItemsSet: true,
        formData: {
          ...formData,
          items: vehicleCheckListItems.map((item) => {
            return {
              'check_list_item': item.check_list_item,
              'last_check_date': item.last_check_date,
              'check_list_id': item.check_list_id,
              'enabled': item.enabled,
              'last_edited_by': item.last_edited_by,
              'last_edited_at': item.last_edited_at
            }
          })
        }
      })
    } else if (checkLists.length && !formData.check_list_id) {
      this.setState({
        formData: {
          ...formData,
          check_list_id: this.getCheckList(checkLists).id
        }
      });
    }

  };

  fetchCheckLists = () => {
    const {
      fetchCheckLists,
      selectedOrganizationId,
      selectedWorkshopId,
      vehicle
    } = this.props;

    const params = {};

    if (selectedOrganizationId) {
      params.organization_id = vehicle.organization_id;
    } else if (selectedWorkshopId) {
      params.workshop_id = selectedWorkshopId;
      params.fleet_organization_id = vehicle.organization_id;
    }

    return fetchCheckLists(params);
  };

  getIsValid = () => {
    const { formData } = this.state;
    let isValid = true;
    formData.items.forEach(item => {
      if (!item.check_list_item || !item.last_check_date) {
        isValid = false;
      }
    });
    return isValid;
  };

  updateFormState = changedObject => {
    const { formData } = this.state;
    const newFormData = Object.assign({}, formData);
    newFormData[changedObject.target] = changedObject.value;
    this.setState({ formData: newFormData });
  };

  submitForm = () => {
    const { formData } = this.state;
    const {
      service,
      selectedWorkshopId,
      selectedOrganizationId,
      closeModal,
      toggleVehicleChecks,
      vehicle
    } = this.props;

    const newFormData = Object.assign({}, formData);

    newFormData.items = formData.items
      .filter((item) => item.check_list_id == formData.check_list_id)
      // A hoitomerkintä is created only for a check that stays selected.
      .map((item) => ({ ...item, create_treatment: !!item.create_treatment && !!item.enabled }));

    if (service === SERVICE_WORKSHOP && selectedWorkshopId) {
      newFormData.workshop = selectedWorkshopId;
    }
    else if (service === SERVICE_FLEET && selectedOrganizationId) {
      newFormData.organization = vehicle.organization_id;
    }

    toggleVehicleChecks(newFormData);

    closeModal();
  };

  getCheckList = (checkLists) => {
    const { service, selectedWorkshopId, selectedOrganizationId } = this.props;

    let checkList = null;

    if (service === SERVICE_WORKSHOP && selectedWorkshopId) {
      checkList = checkLists.find((cl) => cl.list_type == 'workshop');
    }
    else if (service === SERVICE_FLEET && selectedOrganizationId) {
      checkList = checkLists.find((cl) => cl.list_type == 'organization');
    }

    return checkList || checkLists.find((cl) => cl.list_type == 'default');
  };

  getSecondaryCheckList = (checkLists, vehicleCheckListItems) => {
    const { service, selectedWorkshopId, selectedOrganizationId } = this.props;

    let checkList = null;

    if (service === SERVICE_WORKSHOP && selectedWorkshopId) {
      checkList = checkLists.find((cl) => cl.list_type == 'organization');
    }
    else if (service === SERVICE_FLEET && selectedOrganizationId) {
      checkList = checkLists.find((cl) => cl.list_type == 'workshop');
    }

    if (checkList && checkList.items.length) {
      const filteredItems = checkList.items.filter((item) => {
        return vehicleCheckListItems.find((vItem) => (vItem.check_list_item == item.id) && vItem.enabled)
      })
      checkList.items = filteredItems;
    }

    return checkList;
  };

  getVehicleCheckListItem = (item) => {
    const { vehicleCheckListItems } = this.props;
    const selectedItem = vehicleCheckListItems.find((vItem) => vItem.check_list_item == item.id);
    return selectedItem;
  };

  getIsItemSelected = (item) => {
    const { formData } = this.state;

    return !!formData.items.find((fItem) => fItem.check_list_item == item.id && fItem.enabled)
  };

  getLastCheckDate = (item) => {
    const { formData } = this.state;
    const checkedItem = formData.items.find((fItem) => fItem.check_list_item == item.id)

    return checkedItem ? checkedItem.last_check_date : null;
  };

  getLastCheckEditedBy = (item) => {
    const { formData } = this.state;
    const checkedItem = formData.items.find((fItem) => fItem.check_list_item == item.id)

    return checkedItem ? checkedItem.last_edited_by : null;
  };

  getLastCheckEditedAt = (item) => {
    const { formData } = this.state;
    const checkedItem = formData.items.find((fItem) => fItem.check_list_item == item.id)

    return checkedItem ? checkedItem.last_edited_at : null;
  };

  itemToggled = (item) => {
    const { formData } = this.state;
    const newFormData = Object.assign({}, formData);

    if (this.getIsItemSelected(item)) {
      newFormData.items = formData.items.map((vItem) => {
        if (vItem.check_list_item != item.id) {
          return vItem;
        }
        return {
          ...vItem,
          enabled: false,
          create_treatment: false,
        };
      });
    } else {
      const vItem = formData.items.find((fItem) => fItem.check_list_item == item.id);
      if (vItem) {
        newFormData.items = formData.items.map((vItem) => {
          if (vItem.check_list_item != item.id) {
            return vItem;
          }
          return {
            ...vItem,
            enabled: true,
          };
        });
      } else {
        newFormData.items = storeInsertItem(formData.items, {check_list_item: item.id, check_list_id: formData.check_list_id, enabled: true})
      }
    }

    this.setState({
      formData: newFormData
    });

  };

  setLastCheckDate = (it, newDate) => {
    const { formData } = this.state;
    const newFormData = Object.assign({}, formData);

    const checkedItem = formData.items.find((fItem) => fItem.check_list_item == it.id)
    checkedItem.last_check_date = newDate ? moment(newDate).format(dbDateFormat) : null;
    newFormData.items = formData.items.map(item => {
      if (item.id !== checkedItem.check_list_item) {
        return item;
      }
      return {
        ...item,
        ...checkedItem,
      };
    });

    // A new date means the check was just done: offer to record it as a
    // hoitomerkintä too. One already queued simply follows the new date.
    const offerTreatment = !!checkedItem.last_check_date && !checkedItem.create_treatment;

    this.setState({
      formData: newFormData,
      treatmentPromptItem: offerTreatment ? { id: it.id, name: it.name } : null,
    });
  }

  setCreateTreatment = (checkListItemId, createTreatment) => {
    const { formData } = this.state;

    this.setState({
      formData: {
        ...formData,
        items: formData.items.map((item) => (
          item.check_list_item == checkListItemId
            ? { ...item, create_treatment: createTreatment }
            : item
        )),
      },
      treatmentPromptItem: null,
    });
  };

  getPendingTreatments = (checkList) => {
    const { formData } = this.state;

    if (!checkList) {
      return [];
    }

    return checkList.items
      .map((item) => ({
        item,
        formItem: formData.items.find((fItem) => fItem.check_list_item == item.id),
      }))
      .filter(({ formItem }) => formItem && formItem.enabled && formItem.create_treatment && formItem.last_check_date);
  };

  render() {
    const { formData, loading, treatmentPromptItem } = this.state;
    const {
      modalIsOpen,
      closeModal,
      afterOpenModal,
      t,
      vehicle,
      checkLists,
      vehicleCheckListItems
    } = this.props;

    if (loading) {
      return <p></p>; // Placeholder loading indicator
    }

    const checkList = this.getCheckList(checkLists);
    const secondaryCheckList = this.getSecondaryCheckList(checkLists, vehicleCheckListItems);
    const pendingTreatments = this.getPendingTreatments(checkList);

    return (
      <CBMediaQuery>
        {screenSize => (
          <CBModal
            modalIsOpen={modalIsOpen}
            afterOpenModal={afterOpenModal}
            closeModal={closeModal}
            title={t('checkItemsModalTitle')}
            descriptionText={t('checkItemsModalDescription')}
            submitForm={this.submitForm}
            isValid={this.getIsValid()}
            vehicleText={vehicle && vehicle.registration_number}
          >
            <div>
              {
                checkList && vehicleCheckListItems && (
                  <div style={getStyle(screenSize, styles, 'bodyContainer')}>
                    <p style={getStyle(screenSize, styles, 'companyText')}>{checkList.company_name}</p>
                    <table>
                      <thead>
                        <tr>
                          <th style={getStyle(screenSize, styles, 'tableHeading')}>
                          </th>
                          <th style={getStyle(screenSize, styles, 'tableHeading')}>
                            {t('checkNameLabel')}
                          </th>
                          <th style={getStyle(screenSize, styles, 'tableHeading')}>
                            {t('checkIntervalLabel')}
                          </th>
                          <th style={getStyle(screenSize, styles, 'tableHeading')}>
                            {t('lastCheckDate')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          checkList && checkList.items.map((item) => (
                            <tr id={`utooltip-${item.id}`} key={item.id}>
                              <td style={getStyle(screenSize, styles, 'tableTd')}>
                                <CBLabelAndCheckbox
                                  color='blue'
                                  checked={this.getIsItemSelected(item)}
                                  onChange={() => { this.itemToggled(item);}}
                                  additionalStyles={{ marginBottom: 16 }}
                                />
                              </td>
                              <td style={getStyle(screenSize, styles, 'tableTd')}>
                                <p style={getStyle(screenSize, styles, 'text')}>
                                  {item.name}
                                </p>
                              </td>
                              <td style={getStyle(screenSize, styles, 'tableTd')}>
                                <p style={getStyle(screenSize, styles, 'text')}>
                                  {item.check_interval_months}
                                </p>
                              </td>
                              <td style={getStyle(screenSize, styles, 'tableTd')}>
                                {
                                  this.getLastCheckEditedBy(item) && this.getLastCheckEditedAt(item) && (
                                    <Tooltip target={`#utooltip-${item.id}`} content={`${this.getLastCheckEditedBy(item)} ${formatDateTime(this.getLastCheckEditedAt(item))}`} showDelay={1000} hideDelay={100} position='mouse' />
                                  )
                                }
                                <div style={getStyle(screenSize, styles, 'datePickerTopContainer')}>
                                  <div className='datepicker-container-white-bg'>
                                    <CBDatePickerInput
                                      displayedDate={this.getLastCheckDate(item) ? moment(this.getLastCheckDate(item)) : null}
                                      type='date'
                                      dateFormat={finnishDateFormat}
                                      changeDate={(value) => {
                                        this.setLastCheckDate(item, value);
                                      }}
                                      disabled={!this.getIsItemSelected(item)}
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    {
                      !!formData.items.length && !this.getIsValid() && (
                        <p  style={getStyle(screenSize, styles, 'bottomText')}>{t('setLastInspectionDate')}</p>
                      )
                    }
                    {
                      pendingTreatments.length > 0 && (
                        <div style={getStyle(screenSize, styles, 'pendingTreatmentsContainer')}>
                          <p style={getStyle(screenSize, styles, 'bottomText')}>{t('pendingTreatmentsTitle')}</p>
                          {
                            pendingTreatments.map(({ item, formItem }) => (
                              <div key={item.id} style={getStyle(screenSize, styles, 'pendingTreatmentRow')}>
                                <p style={getStyle(screenSize, styles, 'text')}>
                                  {`${item.name} ${moment(formItem.last_check_date).format('DD.MM.YYYY')}`}
                                </p>
                                <p
                                  className='hover-underline'
                                  style={getStyle(screenSize, styles, 'pendingTreatmentRemove')}
                                  onClick={() => this.setCreateTreatment(item.id, false)}
                                >
                                  {t('pendingTreatmentRemove')}
                                </p>
                              </div>
                            ))
                          }
                        </div>
                      )
                    }
                  </div>
                )
              }
              {
                secondaryCheckList && secondaryCheckList.items.length > 0 && vehicleCheckListItems && (
                  <div style={getStyle(screenSize, styles, 'bodyContainer')}>
                    <p style={getStyle(screenSize, styles, 'companyText')}>{secondaryCheckList.company_name}</p>
                    <p style={{color: 'black'}}>{t('checkItemsManagedByOther', { type: secondaryCheckList.list_type == 'workshop' ? t('managedByWorkshop') : t('managedByFleet') })}</p>
                    <table>
                      <thead>
                        <tr>
                          <th style={getStyle(screenSize, styles, 'tableHeading')}>
                          </th>
                          <th style={getStyle(screenSize, styles, 'tableHeading')}>
                            {t('checkNameLabel')}
                          </th>
                          <th style={getStyle(screenSize, styles, 'tableHeading')}>
                            {t('checkIntervalLabel')}
                          </th>
                          <th style={getStyle(screenSize, styles, 'tableHeading')}>
                            {t('lastCheckDate')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          secondaryCheckList && secondaryCheckList.items.map((item) => (
                            <tr id={`#ttooltip-${item.id}`} key={item.id}>
                              <td style={getStyle(screenSize, styles, 'tableTd')}>
                                <CBLabelAndCheckbox
                                  color='blue'
                                  checked={true}
                                  onChange={() => {}}
                                  disabled={true}
                                  additionalStyles={{ marginBottom: 16, cursor: 'not-allowed', opacity: 0.5 }}
                                />
                              </td>
                              <td style={getStyle(screenSize, styles, 'tableTd')}>
                                <p style={getStyle(screenSize, styles, 'text')}>
                                  {item.name}
                                </p>
                              </td>
                              <td style={getStyle(screenSize, styles, 'tableTd')}>
                                <p style={getStyle(screenSize, styles, 'text')}>
                                  {item.check_interval_months}
                                </p>
                              </td>
                              <td style={getStyle(screenSize, styles, 'tableTd')}>
                                {
                                  this.getLastCheckEditedBy(item) && this.getLastCheckEditedAt(item) && (
                                    <Tooltip target={`#ttooltip-${item.id}`} content={`${this.getLastCheckEditedBy(item)} ${formatDateTime(this.getLastCheckEditedAt(item))}`} showDelay={1000} hideDelay={100} position='mouse' />
                                  )
                                }
                                <div style={getStyle(screenSize, styles, 'datePickerTopContainer')}>
                                  <div className='datepicker-container-white-bg'>
                                    <CBDatePickerInput
                                      displayedDate={this.getLastCheckDate(item) ? moment(this.getLastCheckDate(item)) : null}
                                      type='date'
                                      dateFormat={finnishDateFormat}
                                      changeDate={(value) => {
                                        this.setLastCheckDate(item, value);
                                      }}
                                      disabled={true}
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                )
              }
            </div>
            <CBPromptModal
              modalIsOpen={!!treatmentPromptItem}
              closeModal={() => this.setState({ treatmentPromptItem: null })}
              title={t('createTreatmentPromptTitle')}
              text={treatmentPromptItem ? t('createTreatmentPromptText', { name: treatmentPromptItem.name }) : ''}
              buttonText={t('createTreatmentPromptButton')}
              cancelText={t('createTreatmentPromptCancel')}
              performAction={() => this.setCreateTreatment(treatmentPromptItem.id, true)}
            />
          </CBModal>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 32px'
    },
    companyText: {
      color: 'black',
      fontSize: 18,
    },
    datePickerTopContainer: {
      maxWidth: 225,
    },
    checkListItemContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    text: {
      color: 'black',
      fontSize: 14,
    },
    bottomText: {
      marginTop: 16,
      color: 'black',
      fontSize: 14,
    },
    pendingTreatmentsContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    pendingTreatmentRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: 16,
    },
    pendingTreatmentRemove: {
      color: '#0095da',
      fontSize: 14,
      cursor: 'pointer',
      marginLeft: 16,
    },
    tableHeading: {
      fontFamily: 'TitilliumWeb-Regular',
      fontSize: 12,
      paddingLeft: 16,
      paddingBottom: 8,
    },
    tableTd: {
      //border: '1px solid rgba(0, 0, 0, .3)',
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  small: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 16px'
    },
  }
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    service: state.app.service,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedOrganizationId: state.organization.selectedOrganization,
    checkLists: state.checkList.checkLists,
    vehicleCheckListItems: state.checkList.vehicleCheckListItems
  };
}

export default connect(
  mapStateToProps,
  {
    fetchCheckLists: _fetchCheckLists,
    fetchVehicleCheckListItems: _fetchVehicleCheckListItems,
    toggleVehicleChecks: _toggleVehicleChecks
  },
)(translate('CheckLists')(SelectCheckListItemsModal));
